import React from "react";
import Typography from "../../../../Typography";
import { DEFAULT_EMPTY_MESSAGE } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line import/prefer-default-export
export function Empty(_ref) {
  var emptyMessage = _ref.emptyMessage;
  return /*#__PURE__*/_jsx(Typography, {
    color: "lowContrast",
    children: emptyMessage || DEFAULT_EMPTY_MESSAGE
  });
}